import React, { useState } from "react";
import { Footer } from "../../containers";
import { PageHeader } from "../../components";

function DeleteAccount({ data }) {
  const [email, setEmail] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [code, setCode] = useState("");
  const [isLoading, setLoader] = useState(false);
  const [verified, setVerified] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [cookie, setCookie] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // DELETE ACCOUNT
    if (verified) {
      const requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          auth_token: cookie,
        }),
      };

      console.log(requestOptions);

      setLoader(true);
      const response = await fetch(
        "https://leetask.herokuapp.com/api/users/delete-web",
        requestOptions
      );
      setLoader(false);

      if (!response.ok) {
        alert("Something went wrong. Please try again later.");
        return;
      }
      setDeleted(true);

      return;
    }

    // VERIFY CODE
    if (codeSent) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          code: code,
        }),
      };

      setLoader(true);
      const response = await fetch(
        "https://leetask.herokuapp.com/api/auth/checkreset",
        requestOptions
      );
      setLoader(false);

      if (!response.ok) {
        alert("Something went wrong. Please try again later.");
        return;
      }

      const data = await response.text();
      const body = JSON.parse(data);

      setCookie(body.token);
      setVerified(true);

      return;
    }

    // SEND VERIFICATION CODE
    const regx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regx.test(email) && email.length > 0) {
      e.target.querySelector("#email").style = "rgb(41 43 62 / 50%);";

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
        }),
      };

      setLoader(true);
      const response = await fetch(
        "https://leetask.herokuapp.com/api/auth/resetpass",
        requestOptions
      );
      setLoader(false);
      if (!response.ok) {
        const data = await response.text();
        const errorObject = JSON.parse(data);
        const errorMessage = errorObject.Error || "Unknown error";
        alert(`Something went wrong: ${errorMessage}`);
        return;
      }
      setCodeSent(true);
    } else {
      e.target.querySelector("#email").style =
        "border-color: " + "rgb(216 2 2 / 71%);";
    }
  };

  return (
    <div className="pageBody">
      <PageHeader Brand={data.Brand} />
      <main>
        <div id="delete_account">
          <h3>Delete account</h3>
          {deleted ? (
            <h4>
              Your account has been successfully deleted. We're sorry to see you
              go.
            </h4>
          ) : (
            <form onSubmit={handleSubmit} className="delete_account_form">
              <div className="row">
                <label htmlFor="email" type="label">
                  Keep in mind that this action is irreversible and will
                  permanently delete all your account data.
                </label>
                <input
                  id="email"
                  type="text"
                  placeholder="Email*"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                />
              </div>
              {codeSent && !verified && (
                <div className="row">
                  <label h tmlFor="code" type="code">
                    Please enter the 4-digit code sent to your email.
                  </label>
                  <input
                    id="code"
                    type="text"
                    placeholder="4-digit code*"
                    onChange={(e) => {
                      setCode(e.target.value);
                    }}
                    required
                  />
                </div>
              )}

              <input
                type="submit"
                disabled={isLoading}
                value={
                  isLoading
                    ? "Loading..."
                    : codeSent
                    ? verified
                      ? "Delete Account"
                      : "Verify"
                    : "Send"
                }
              />
            </form>
          )}
        </div>
      </main>
      <Footer data={data.Footer} brand={data.Brand} />
    </div>
  );
}

export default DeleteAccount;
